export default __webpack_public_path__ + "static/media/logo-eaeo.cd32f468.png";